import { TextArea } from "@tql/ui-components-react/kendo/inputs";
import type { InputHTMLAttributes } from "react";

import { PAYMENT_CONSTRAINTS } from "../../utils/constants.ts";

type PaymentDescriptionProps = {
	description: string;
	onDescriptionChange: (value: string) => void;
	isLumpSumPayment: boolean;
};

export function PaymentDescription({
	description,
	onDescriptionChange,
	isLumpSumPayment,
}: Readonly<PaymentDescriptionProps>) {
	return (
		<>
			<div
				style={{
					marginTop: "1rem",
					display: "flex",
					justifyContent: "space-between",
				}}
			>
				<div style={{ display: "flex" }}>
					<p>Payment Description</p>
					{isLumpSumPayment ? <span className={"required"}> *</span> : null}
				</div>
				<p>
					({description.length} / {PAYMENT_CONSTRAINTS.DESCRIPTION_MAX_LENGTH})
				</p>
			</div>

			<div>
				<TextArea
					inputAttributes={
						{
							"data-testid": "payment-description-textarea",
						} as InputHTMLAttributes<HTMLInputElement>
					}
					onChange={(e) => onDescriptionChange(e.target.value ?? "")}
					placeholder={
						isLumpSumPayment
							? "Please specify how the lump sum payment should be allocated."
							: "Type Payment Description Here..."
					}
					rows={5}
					value={description}
				/>
			</div>
		</>
	);
}
